import * as React from 'react';

import { useLightbox } from '../../providers/lightbox';

const LightBox = function() {
  const lightbox = useLightbox();

  const slide    = React.useMemo(() => {
    return lightbox.slides[lightbox.current];
  }, [lightbox.current, lightbox.slides]);
  const image    = React.useMemo(() => {
    if (!slide) {
      return;
    }

    return typeof slide.image === 'string' ? slide.image : slide.image[0];
  }, [slide?.image]);
  const filename = React.useMemo(() => {
    return image?.substring(0, image.lastIndexOf('.'));
  }, [image]);
  const ext      = React.useMemo(() => {
    return image?.substring(image.lastIndexOf('.') + 1, image.length);
  }, [image]);

  const handleKeyDown = React.useCallback((event) => {
    switch (event.key) {
      case 'Escape':
        lightbox.closeLightbox();

        break;

      case 'ArrowLeft':
        if (lightbox.current > 0 || lightbox.loop) {
          lightbox.navigateLightbox(lightbox.current === 0 ? lightbox.slides.length - 1 : lightbox.current - 1);
        }

        break;

      case 'ArrowRight':
        if (lightbox.current < lightbox.slides.length - 1 || lightbox.loop) {
          lightbox.navigateLightbox(lightbox.current === lightbox.slides.length - 1 ? 0 : lightbox.current + 1);
        }

        break;
    }
  }, []);
  const handleClose   = React.useCallback((event) => {
    event.preventDefault();
    event.stopPropagation();

    lightbox.closeLightbox();
  }, []);
  const changeSlides  = React.useCallback((event, index) => {
    event.preventDefault();
    event.stopPropagation();

    lightbox.navigateLightbox(index);
  }, []);

  React.useEffect(() => {
    if (lightbox.open) {
      document.addEventListener('keydown', handleKeyDown);
    } else {
      document.removeEventListener('keydown', handleKeyDown);
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown, lightbox.open]);

  if (!lightbox.open || !image) {
    return null;
  }

  return (
    <div
      className={'lightBox overlay'}
      onClick={handleClose}
      style={{ backgroundColor: lightbox.overlayColor }}
    >
      <div className={'container'}>
        <div className={'content animated'}>
          <picture>
            {!!ext
              ? (
                <>
                  <source
                    srcSet={`${filename}.webp`}
                    type={'image/webp'}
                  />
                  <source
                    srcSet={`${filename}.png`}
                    type={'image/png'}
                  />
                </>
              )
              : (
                <>
                  <source
                    srcSet={`${image}.webp`}
                    type={'image/webp'}
                  />
                  <source
                    srcSet={`${image}.png`}
                    type={'image/png'}
                  />
                </>
              )
            }
            <img
              alt={slide.alt || slide.title || ''}
              src={`${image}${(ext === 'png' || ext === 'webp') ? '' : `.png`}`}
            />
          </picture>
        </div>
      </div>
      <div className={'title'}>{lightbox.titleAttr}</div>
      <div className={'num'}>{lightbox.current}/{lightbox.slides.length}</div>
      <div
        className={'close'}
        dangerouslySetInnerHTML={{ __html: lightbox.htmlClose }}
        onClick={handleClose}
      />
      {(lightbox.current > 0 || lightbox.loop) && (
        <div
          className={'prev'}
          dangerouslySetInnerHTML={{ __html: lightbox.htmlPrev }}
          onClick={(event) => {
            changeSlides(event, lightbox.current === 0 ? lightbox.slides.length - 1 : lightbox.current - 1);
          }}
        />
      )}
      {(lightbox.current < lightbox.slides.length - 1 || lightbox.loop) && (
        <div
          className={'next'}
          dangerouslySetInnerHTML={{ __html: lightbox.htmlNext }}
          onClick={(event) => {
            changeSlides(event, lightbox.current === lightbox.slides.length - 1 ? 0 : lightbox.current + 1);
          }}
        />
      )}
    </div>
  );
};
export default LightBox;